import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { InParkingCardDetail } from 'src/features/cards/types/card';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/:cardId/change-plate/';

type ChangeCardIdentifierFnType = typeof changeCardIdentifier;

type ChangeCardIdentifierDTO = {
    parkingId: string;
    cardId: number;
};

const changeCardIdentifier = ({
    parkingId,
    cardId,
    ...data
}: ChangeCardIdentifierDTO): Promise<InParkingCardDetail> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cardId }), data);
};

interface UseChangePricingPlanCardOptions extends MutationConfig<ChangeCardIdentifierFnType, GeneralSmartParkError> {}

const useChangeCardIdentifier = (options: UseChangePricingPlanCardOptions = {}) =>
    useMutation({
        mutationFn: changeCardIdentifier,
        ...options,
    });

export { useChangeCardIdentifier, changeCardIdentifier, type ChangeCardIdentifierDTO, RESOURCE };
